import { useState, useEffect } from "react";

export const useTypewriter = (text: string, duration: number = 2000) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (!text) {
      setDisplayedText("");
      setIsComplete(false);
      return;
    }

    let currentIndex = 0;
    const totalChars = text.length;
    const intervalTime = duration / totalChars;

    const interval = setInterval(() => {
      if (currentIndex < totalChars) {
        setDisplayedText(text.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        setIsComplete(true);
        clearInterval(interval);
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [text, duration]);

  return { displayedText, isComplete };
};
